import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is SEO?",
    answer: `<p>Search engine optimization, often referred to as SEO, is centered around the concept of optimization. By optimizing your brand’s online presence—including your website, content, and social media platforms—you enhance its visibility across the web. This increased visibility helps your website secure a spot on the first page of search engine results pages (SERPs).</p>`,
  },
  {
    question: "How does SEO work?",
    answer: `<p>SEO leverages elements like keywords, internal and external links, and optimized content to help search engines discover and rank websites higher on search engine results pages (SERPs).</p>`,
  },
  {
    question:
      "Do I need different SEO strategies for different search engines?",
    answer: `<p>In simpler terms, search engines like Ecosia and Yahoo use Bing as their underlying engine, so the optimization strategies for them are the same as those for Bing. However, the appearance of their search results pages differs.</p>`,
  },
  {
    question: "How much does it cost to implement a SEO campaign?",
    answer: `<p>Establishing a well-defined SEO budget is essential for maximizing your SEO efforts. While the optimal budget varies depending on the business, the average monthly investment typically falls between $2,500 and $7,500, representing approximately 5-10% of the overall marketing budget.</p>`,
  },
  {
    question: "Can I do SEO myself?",
    answer: `<p>Absolutely, you can implement a basic SEO strategy on your own with some knowledge and experimentation. However, SEO requires a significant investment of time and attention to detail. To do it effectively, you'll need to address both technical and on-page SEO aspects and stay informed about updates to search engine algorithms.</p>`,
  },
  {
    question: "What factors affect Google ranking?",
    answer: `<p>Search algorithms analyze a variety of factors to provide you with the most relevant results. These factors include the keywords in your query, the relevance and usability of the pages, the credibility of the sources, as well as your location and settings. The importance of each factor can change based on the specifics of your query.</p>`,
  },
  {
    question: "Will blogging help SEO?",
    answer: `<p>Blogging enhances SEO by enabling you to target a broader range of keywords beyond your main pages. It also boosts other ranking factors, including the freshness of your content, the accumulation of backlinks, and the increase in indexed pages.</p>`,
  },
  {
    question: "Is SEO better than paid advertising?",
    answer: `<p>If you’re looking for a long-term, sustainable strategy, SEO could be the right choice for you. For rapid visibility, pay-per-click marketing might be more suitable. Remember, integrating both approaches can enhance your overall digital marketing strategy.</p>`,
  },
  {
    question: "How long does SEO take?",
    answer: `<p>Search engine optimization (SEO) is a continuous effort to enhance your website's visibility on search engines. Typically, it takes between three to six months to start seeing results, although the exact timeline can vary based on various factors specific to your website.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Search Engine Optimization FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
